// import {
//     AllInclusive,
//     Favorite,
//     Timer,
//     TrendingUp,
//     Whatshot,
// } from "@mui/icons-material";
import { Box } from "@mui/material";
import { useStore } from "ra-core";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { InfiniteList } from "../../components";
import { useWebsite } from "../../hooks";
import { find, makeLikeATree, type CategoryTree } from "../../models";
import { round } from "../../util";
import { OfferFilters } from "./aside";
import { ShopGrid } from "./grid";

export const Shop = (): JSX.Element => {
    // const tabs = [
    //     { label: "All", icon: AllInclusive, value: "" },
    //     { label: "On Sale", icon: Whatshot, value: "sale" },
    //     { label: "Top Selling", icon: TrendingUp, value: "top" },
    //     { label: "Top Rated", icon: Favorite, value: "favorite" },
    //     { label: "New", icon: Timer, value: "new" },
    // ];
    const [open, setOpen] = useStore("filters.open", false);
    const [query] = useSearchParams();
    const website = useWebsite();

    const categories = query
        .get("categories")
        ?.split("-")
        .map(x => Number.parseInt(x)) ?? [];
    const color =
        query
            .get("color")
            ?.split("-")
            .map(x => Number.parseInt(x)) ?? [];
    const activeBrandIds =
        query
            .get("brands")
            ?.split("-")
            .map(x => Number.parseInt(x)) ?? [];

    const root = useMemo(() => {
        const all = makeLikeATree(website.categories);
        return all.size > 1 ? { 
            brands: new Set(website.brands.map(x => x.brandId)), 
            categories: new Set(), 
            children: all 
        } as CategoryTree : all.values().toArray()[0];
    }, [website]);

    const tree = useMemo(() => {
        return categories.length > 0 ? find(root, new Set(categories)) : root;
    }, [root, categories])
    
    const tags = query.get("tag")?.split(",") ?? ([] as string[]);
    const rating = Number.parseFloat(query.get("rating") ?? "0");
    const min = round(Number.parseFloat(query.get("min") ?? "0") / (1 + website.taxRate));
    const max = round(Number.parseFloat(query.get("max") ?? "0") / (1 + website.taxRate));
    const txt = query.get("txt");

    return (
        <>
            <meta name="description" content={`Browse our products, bundles, services and special offers.`} />
            <InfiniteList
                emptyWhileLoading={false}
                disableAuthentication
                component={Box}
                open={open}
                onOpen={setOpen}
                resource="shop"
                perPage={12}
                filter={{
                    categories: categories.length ? categories : [],
                    brands: activeBrandIds,
                    rating,
                    min,
                    max,
                    tags,
                    txt,
                    color
                }}
                sort={{ field: query.get("sort") ?? "name", order: (query.get("order") as "ASC" | "DESC") ?? "ASC" }}
                queryOptions={{ enabled: !!website.accountId, meta: { headers: { "account-id": website.accountId } } }}
                aside={<OfferFilters open={open} tree={tree} activeBrands={activeBrandIds} />}
            >
                <ShopGrid />
            </InfiniteList>
        </>
    );
};
